import {gql} from '@apollo/client';

export const boardFromQueries = {
    GET_ALL_BOARD_FORMS: gql`
        query GetAllBoardForm($where: BoardFormFilterInput) {
            allBoardForm(where: $where) {
                id
                title
                boardId
                summaryViews {
                    value
                    uniqueId
                }
                formFieldsData {
                    isMultiValue
                    columnSize
                    defaultValue {
                        options {
                            label
                            value
                            color
                            textColor
                        }
                    }
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                    validationMessage
                    uniqueId
                    fieldCategory
                    fieldType
                    dataType
                    regularExpression
                    title
                    placeHolder
                    helperText
                    isRequired
                    order
                    shouldUseAsTheFieldToCreateItem
                    formula
                    format
                    isReadOnly
                }
                isDefault
            }
        }
    `,
};
